module.exports = __webpack_public_path__ + "img/fk1.deea129a.png";